/**
 * The herbalist's round worktable (lifted from lantern-water's `world.js`
 * `createShop`): the top, pedestal and four splayed legs, a mortar and pestle,
 * three vessels, a candle, and a copper alembic with its still-head and
 * receiving pipe. Origin: the table's centre on the floor (the prototype's
 * (-4.5, 0.5)). No params. Its collider and the "notes" interaction are the
 * scene's.
 */
import * as THREE from 'three';
import { apothecaryVessel, candle } from '../apothecary.ts';
import type { Prefab } from './types.ts';

export const prefab: Prefab = {
  id: 'worktable',
  buildPrefab(ctx) {
    const root = new THREE.Group();
    const { m, kit } = ctx;
    let bottleIndex = 0;
    const bottle = (x: number, y: number, z: number, size: number): void => {
      apothecaryVessel(kit, root, x, y, z, size, bottleIndex);
      bottleIndex += 1;
    };
    ctx.cylinder(root, 0, 0.8, 0, 1.08, 0.16, m.wood);
    ctx.cylinder(root, 0, 0.37, 0, 0.15, 0.74, m.darkWood);
    for (const s of [-1, 1]) {
      ctx.line(root, [0, 0.35, 0], [s * 0.8, 0.08, 0], 0.15, m.darkWood);
      ctx.line(root, [0, 0.35, 0], [0, 0.08, s * 0.8], 0.15, m.darkWood);
    }
    ctx.cylinder(root, 0, 0.98, 0, 0.28, 0.26, m.stone, 0.85);
    ctx.line(root, [-0.05, 1.03, 0], [0.25, 1.37, 0], 0.085, m.cream);
    bottle(-0.5, 0.9, -0.4, 0.32);
    bottle(0.5, 0.9, 0.3, 0.3);
    candle(ctx, root, 0.4, 0.91, -0.4);
    // A copper alembic and receiving bottle make this a working herbalist's table.
    const copper = kit.shared('worktable:copper', () => new THREE.MeshStandardMaterial({ color: '#b98557', metalness: 0.65, roughness: 0.34 }));
    ctx.mesh(root, ctx.sphere, copper, -0.22, 1.27, -0.42, 0.3, 0.36, 0.3);
    ctx.cylinder(root, -0.22, 1.61, -0.42, 0.14, 0.28, copper, 0.7);
    ctx.mesh(root, kit.shared('worktable:still-head', () => new THREE.ConeGeometry(0.22, 0.2, 12)), copper, -0.22, 1.84, -0.42);
    const pipe = new THREE.CatmullRomCurve3([new THREE.Vector3(-0.22, 1.86, -0.42), new THREE.Vector3(0.08, 1.99, -0.42), new THREE.Vector3(0.38, 1.74, -0.38), new THREE.Vector3(0.5, 1.3, -0.35)]);
    ctx.mesh(root, new THREE.TubeGeometry(pipe, 18, 0.033, 6, false), copper, 0, 0, 0);
    bottle(0.5, 0.9, -0.35, 0.22);
    return { root, sockets: { candle: [0.4, 1.33, -0.4] } };
  },
};
